import { ID } from 'types';
import { LineItemTableColumnSettings } from '@components/bid_request/details/types';

interface GetColIndexParams {
  columnSettings: LineItemTableColumnSettings[];
  headerId: ID;
}

/**
 * Resolves a column's Handsontable index from its header id, or -1 when absent.
 *
 * Deliberately absent from the `./index.ts` barrel. That barrel re-exports 33 siblings, so a
 * leaf cell renderer importing through it would pull all 33 into its module graph to reach an
 * 11-line lookup. `LineItemNameRenderer` and `SmartBaselineBenchmarkRenderer` therefore import
 * this file directly, and should keep doing so. Do not "fix" the deep imports by adding a
 * barrel line.
 */
export const getColIndex = ({ columnSettings, headerId }: GetColIndexParams) => (
  columnSettings.findIndex((column: LineItemTableColumnSettings) => column.id === headerId)
);
